import React from 'react';

/**
 * Componente removido - não força mais redirecionamento automático.
 * Usuários podem navegar livremente independente do perfil selecionado.
 */
const ProfileRedirectHandler: React.FC = () => {
  return null;
};

export default ProfileRedirectHandler;





